export default __webpack_public_path__ + "static/media/placeholder_dummy2016-illustrator01-de.42f88a07.png";